import { useEffect, useState } from "react";

const ListProductPage = ({
    collectionPageSku,
    pushedToShopifySkus,
    filterPage,
    view,
    allSku,
    allPushedToShopifySku,
    searchSku
}) => {

    const [filteredSku,setFilteredSku] = useState(collectionPageSku)

    useEffect(() => {
        const lowerQuery = searchSku.trim().toLowerCase();
    
        const seenSkus = new Set(); // to track unique skus
    
        const filtered = collectionPageSku.filter((item) => {
            const title = item.product_title?.toLowerCase() || "";
            const sku = item.sku?.toLowerCase() || "";
    
            const matches = sku === lowerQuery || title.includes(lowerQuery);
    
            if (matches && !seenSkus.has(sku)) {
                seenSkus.add(sku);
                return true;
            }
    
            return false;
        });
    
        setFilteredSku(filtered);
    }, [searchSku, collectionPageSku]);

    return (
        <>
            <div className={` ${filteredSku.length === 0 ? '' : 'grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4'} `}>
                {

                        filteredSku.length > 0 && filteredSku.map((data) => {
                        let isPushedToshopify = pushedToShopifySkus?.includes(data.sku);
                        return <div
                            className={`product-card ${isPushedToshopify ? 'bg-green-50' : 'bg-red-50'} border border-blue-500 rounded-lg shadow overflow-hidden cursor-pointer hover:border-blue-500 transition-colors duration-200 relative`}

                        >
                            {isPushedToshopify && (
                                <div className="absolute top-2 right-2 bg-green-500 text-white text-xs font-semibold px-2 py-0.5 rounded-full">
                                    Pushed
                                </div>
                            )}
                            <div className="p-4">
                                <div className="flex justify-between items-start">
                                    <div>
                                        <h3 className="text-lg font-medium text-gray-900 mb-1">{data.product_title}</h3>
                                        <p className="text-sm text-gray-500 mb-2">{data.sku}</p>
                                    </div>
                                    <img
                                        src={data.image || "/noimage.jpg"}
                                        alt="Product"
                                        className="h-16 w-16 object-cover rounded"
                                    />
                                </div>
                                <div className="mt-2 text-xs text-blue-600 font-medium">
                                    
                                    <b>Pushed To:</b> {
                                        [
                                        // allPushedToShopifySku?.collection_page?.some(check => check === data.sku) && "Collection Page",
                                        allPushedToShopifySku?.product_page?.some(check => check === data.sku) && "Product Page",
                                        allPushedToShopifySku?.cart_page?.some(check => check === data.sku) && "Cart Page",
                                        allPushedToShopifySku?.before_checkout_page?.some(check => check === data.sku) && "Cart Drawer Page",
                                        allPushedToShopifySku?.checkout_page?.some(check => check === data.sku) && "Checkout Page",
                                        allPushedToShopifySku?.post_purchase_page?.some(check => check === data.sku) && "Post Purchase Page"
                                        ]
                                        .filter(Boolean) // falsy values (false/null) hata dega
                                        .join(", ") || "No Pushed Yet"
                                    }
                                </div>

                                <div class="mt-1 text-xs text-yellow-800">
                                <b>Saved In:</b> {
                                        [
                                            // allSku.collectionPageSku.some(check => check.sku === data.sku) && "Collection Page",
                                            allSku.productPageSku.some(check => check.sku === data.sku) && "Product Page",
                                            allSku.cartPageSku.some(check => check.sku === data.sku) && "Cart Page",
                                            allSku.beforeCheckoutPageSku.some(check => check.sku === data.sku) && "Cart Drawer Page",
                                            allSku.CheckoutPageSku.some(check => check.sku === data.sku) && "Checkout Page",
                                            allSku.postPurchasePageSku.some(check => check.sku === data.sku) && "Post Purchase Page"
                                        ]
                                            .filter(Boolean)
                                            .join(", ") || "No Saved Yet"
                                        }
                                </div>
                                <div className="mt-3 flex justify-between items-center">
                                    <span className="text-sm font-medium text-gray-900">{data.together_customer_count || 0} Customers</span>
                                    <span className="text-sm font-medium text-gray-900 ">
                                        {data.totalPurchasedTogether || 0} Orders
                                    </span>
                                </div>
                            </div>
                        </div>
                    })
                }
                {filteredSku.length == 0 &&
                    <div >
                        <div class="flex flex-wrap gap-4 w-full">
                            <div class="w-full  text-center py-12 bg-white rounded-lg shadow">
                                <i class="fas fa-box-open text-4xl text-gray-400 mb-4"></i>
                                <h3 class="text-lg font-medium text-gray-900 mb-1">No products found</h3>
                                <p class="text-gray-500 max-w-md mx-auto">Try adjusting your search or filter to find what you're looking for.</p>
                            </div>
                        </div>
                    </div>


                }

            </div>

        </>
    )
}

export default ListProductPage;